import React from "react";
import { Provider } from "react-redux";
import { ThemeProvider } from "@ts-digital/vrc";
import store from "../store";
import LanguageMiddleware from "./languageMiddleware";

const RoutesView = () => {

  return (
    <Provider store={store}>
      <ThemeProvider>
        <LanguageMiddleware />
      </ThemeProvider>
    </Provider>
  );
};

// expose store when run in Cypress
if (window.Cypress) {  
  window.store = store;
}

export default RoutesView;

